import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { PasswordReset } from './pages/password-reset/password-reset';
import { Liquidations } from './features/liquidations/liquidations/liquidations';
import { LiquidationDetail } from './features/liquidations/liquidation-detail/liquidation-detail';
import { MyAccount } from './pages/my-account/my-account';
import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { partnerAppGuard } from './core/authentication/partner-app-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['']);
const redirectLoggedInToDashboard = () => redirectLoggedInTo(['/liquidations']);

export const routes: Routes = [
    { path: '', component: Login, canActivate: [AuthGuard, partnerAppGuard], data: { authGuardPipe: redirectLoggedInToDashboard } },
    { path: 'password-reset', component: PasswordReset, canActivate: [AuthGuard, partnerAppGuard], data: { authGuardPipe: redirectLoggedInToDashboard } },
    { path: 'my-account', component: MyAccount, canActivate: [AuthGuard, partnerAppGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
    { path: 'liquidations', component: Liquidations, canActivate: [AuthGuard, partnerAppGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
    { path: 'liquidations/:id', component: LiquidationDetail, canActivate: [AuthGuard, partnerAppGuard], data: { authGuardPipe: redirectUnauthorizedToLogin } },
    { path: '**', redirectTo: '' }
];
